import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface CareerJob {
  id: number;
  uid: string;
  position_category: string;
  title: string;
  min_experience: number;
  max_experience: number;
  min_ctc: number;
  max_ctc: number;
  location: string;
  description: string;
  status: string;
}

@Injectable({
  providedIn: 'root'
})
export class CareerService {
  private apiUrl = environment.baseUrl  + environment.FetchCareerDetails;



  constructor(private http: HttpClient) {}

  getJobs(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl).pipe(
     catchError((err) => {
      console.error('Error fetching jobs', err);
      return of([]); // fallback empty
    })

    );
  }
  
  // Fetch internship availability + details
  // fetchInternships(): Observable<any> {
  //   return this.http.get<any>(this.apiFetIntershipUrl);
  // }



}
